/**
 * The main api service
 */
import http from '@util/http';
import { core, xxcrm } from '../req';

/**
 * 保护的客户列表
 */
export async function queryProtectionList(params) {
  return http.get(xxcrm.CUSTOM_PROTECTION_LIST, params);
}

/**
 * 保护的客户历史列表
 */
export async function queryProtectionHistoryList(params) {
  return http.get(xxcrm.CUSTOM_PROTECTION_HISTORY, params);
}

/**
 * 保护客户查询
 */
export async function queryProtectionSearch(name) {
  return http.get(xxcrm.CUSTOM_PROTECTION_SEARCH, { name });
}

/**
 * 添加客户保护
 */
export async function querySaveProtection(params) {
  return http.post(xxcrm.CUSTOM_PROTECTION_SAVE, params);
}

/**
 * 客户明细
 */
export async function queryProtectionInfo(uuid) {
  return http.get(xxcrm.CUSTOM_PROTECTION_INFO, { uuid });
}

/**
 * 续保
 */
export async function queryProtectionRenewal(uuid) {
  return http.get(xxcrm.CUSTOM_PROTECTION_RENEWAL, { uuid });
}

/**
 * 取消续保
 */
export async function queryCancelProtection(uuid) {
  return http.get(xxcrm.CUSTOM_PROTECTION_CANCEL, { uuid });
}

/**
 * 获取行业列表
 */
export async function queryIndustryList() {
  return http.get(core.DICT_INDUSTRY_LIST);
}



// WEBPACK FOOTER //
// ./src/api/xxcrm/protect.js